// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fgPflNFOxU1I88 {\n  vertical-align: bottom;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "fgPflNFOxU1I88"
};
export default ___CSS_LOADER_EXPORT___;
